export default class CatalogAccordion {

  constructor () {

    this.options = {
      el: '.js--accordion',
      activeClass: 'js--init',
    };

    this.$el = $(this.options.el).not('.js--init');
    this.$body = $('body');

    return this;
  }


  init () {

    let _this = this;


    this.$el.find('ul').each(function (index, element) {
      let $ul = $(element);

      $ul.css('max-height', $ul.outerHeight(true));
    });

    this.$el.find('ul').addClass('block-short active').addClass('transition');


    this.$body.on('click', 'h4', function () {
      let $this = $(this);
      let $ul = $this.next();

      $this.toggleClass('active');
      $ul.toggleClass('active');
    });

  }


  render () {
    if (this.$el.length) {
      this.init();
    }
    return this;
  }

}
